const BaseComponent = require('base/base-component');

class Card extends BaseComponent {}
module.exports = Card;
